export default __webpack_public_path__ + "static/media/double-right-blue.3e6a9542.svg";